import { FC, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { bool, number } from "yup";

import { GetSoilList } from "../../redux/actions/soilAction";

import Pagination from "../../components/pagination";
import { hasPermission } from "../../config/permissionUtils";
const Soil: FC = () => {
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions, loading, error } = usePermissions();
  const dispatch = useDispatch<AppDispatch>();
  const [CurrentPage, SetCurrentPage] = useState(1);
  const [pgsize, Setpgsize] = useState(10);

  const [farm_Id, set_farm_Id] = useState("");
  const [point_Id, set_Point_Id] = useState("");
  const [treatment_Id, set_Treatment_Id] = useState("");
  const [treatment_Name, set_treatment_Name] = useState("");


  const [TotalRecords, setTotalRecords] = useState();

  const [soilList, setsoilList] = useState({
    data: [],
    pageIndex: number,
    pageSize: number,
    totalrecords: number,
    totalPage: number,
    hasPreviousPage: bool,
    hasNextPage: bool,
  });

  useEffect(() => {
    searchPoketProfile();
  }, [CurrentPage, farm_Id, point_Id,treatment_Id,treatment_Name]);

  const searchPoketProfile = () => {
    var payload = {
      PageIndex: CurrentPage,
      PageSize: pgsize,
      SkipRow: pgsize * (CurrentPage - 1),
      SortBy: null,
      SortOrder: "desc",
      fid: null,
      globalid: "",
      treatment: null,
      farm_id: farm_Id,
      treat_id: treatment_Id,
      treatname: treatment_Name,
      point_id: point_Id,
    };
    dispatch(
      GetSoilList(payload, (response: any) => {
        if (response.status != 500) {
          console.log(response);
          setsoilList(response);
          setTotalRecords(response.totalrecords);
        }
      })
    );
  };
  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4">
          <div className="container">
            <div className="d-flex justify-content-between align-items-end">
              <div>
                <div className="loginHd mb-1">
                  <span className="d-block">Soil</span>
                </div>
                <div className="bradcrumb">
                  <NavLink to="/dashboard">Dashboard</NavLink> &gt; Soil
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="filterCon">
          <div className="container">
            <div className="d-flex flex-wrap align-items-center pt-3 pb-3">
              <div className="searchBy">Search By</div>
              <ul className="d-flex flex-wrap filterBox">
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Farm ID</span>
                    <input
                      type="text"
                      className="filterInput"
                      onChange={(event) => set_farm_Id(event.target.value)}
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Point ID</span>
                    <input
                      type="text"
                      className="filterInput"
                      onChange={(event) =>
                        set_Point_Id(event.target.value)
                      }
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Treatment ID </span>
                    <input
                      type="text"
                      className="filterInput"
                      onChange={(event) =>
                        set_Treatment_Id(event.target.value)
                      }
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Treat Name</span>
                    <input
                      type="text"
                      className="filterInput"
                      onChange={(event) =>
                        set_treatment_Name(event.target.value)
                      }
                    />
                  </div>
                </li>
                <li className="btn">
                  <button type="button">
                    <span className="material-icons">search</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 mt-2 whtBg">
          <div className="container">
            <div className="tableBox">
              <table>
                <thead></thead>
                <tr>
                  <th>Farm ID</th>
                  <th>State</th>
                  <th>Point ID</th>
                  <th>Treat ID</th>
                  <th>Treatment Name</th>
                  {hasPermission(
                    permissions,
                    roleid,
                    "Soil",
                    "view"
                  ) && <th>Action</th>}
                </tr>
                {soilList.data && (
                  <tbody>
                    {soilList.data.map((item: any) => (
                      <tr key={"id" + item.id}>
                        <td>{item.farm_id}</td>
                        <td>{item.state}</td>
                        <td>{item.point_id}</td>
                        <td>{item.treat_id}</td>
                        <td>{item.treatname}</td>
                        <td>
                          <div className="actionbtn d-flex">
                            {hasPermission(
                              permissions,
                              roleid,
                              "Soil",
                              "view"
                            ) && (
                              <NavLink
                                to={{
                                  pathname: `/Soil/view/${item.farm_id}/${item.treat_id}/${item.point_id}`,
                                }}
                                title="View"
                              >
                                <span className="material-icons-outlined">
                                  visibility
                                </span>
                              </NavLink>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center pt-3 pb-3">
              <div className="totalResul">{TotalRecords}</div>
              <Pagination
                GoToPage={(value: number) => {
                  SetCurrentPage(value);
                }}
                PageIndex={Number(soilList.pageIndex)}
                TotalPages={Number(soilList.totalPage)}
                hasNextPage={Boolean(soilList.hasNextPage)}
                hasPreviousPage={Boolean(soilList.hasPreviousPage)}
              />
              <div></div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Soil;
